module.exports = __webpack_public_path__ + "img/Astralis-red.18a1ddd2.png";